import React from "react";
import { Box } from "@mui/material";
import { SvgIconUrlProps } from "./types";

const SvgIconUrl: React.FC<SvgIconUrlProps> = ({ src, width, height, size = 22, title, color }) => {
  return (
    <Box
      component="span"
      role={title ? "img" : undefined}
      aria-label={title}
      sx={{
        width: width ? width : size,
        height: height ? height : size,
        display: "inline-block",
        bgcolor: color ? color : "currentColor",
        maskImage: `url(${src})`,
        maskRepeat: "no-repeat",
        maskPosition: "center",
        maskSize: "contain",
        WebkitMaskImage: `url(${src})`,
        WebkitMaskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        WebkitMaskSize: "contain",
      }}
    />
  );
};

export default SvgIconUrl;
